import { render, staticRenderFns } from "./LayoutChat.vue?vue&type=template&id=5f401917&"
import script from "./LayoutChat.vue?vue&type=script&lang=ts&"
export * from "./LayoutChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports